import YourProfile from './components/YourProfile';
import YourCompany from './components/YourCompany';
import ManageTwoFactorAuth from './components/ManageTwoFactorAuth';
import EmailAddresses from './components/EmailAddresses';

import moment from 'moment';

export default {
    name: 'app-settings',
    components: {
        YourProfile,
        YourCompany,
        ManageTwoFactorAuth,
        EmailAddresses
    },
    props: [],
    data() {
        return {
            userData: null,
            yourProfile: {},
            yourCompany: {},
            manage2FA: {},
            emailAddresses: {},

            questionnaire: {
                scoreDefinition: {}
            },
            topics: [],

            countries: [],
            genders: [],

            /* My company */
            jobLevels: [],
            jobIndustries: [],
            departments: [],

            tab: null,
            twoFactorTabName: 'Two-Factor Authentication',
            tabs: [{ title: 'Your Profile', hash: '#yourProfile', index: 0 },
                { title: 'Your Company', hash: '#yourCompany', index: 1 },
                { title: 'Email Addresses', hash: '#emailAddresses', index: 3 }]
        }
    },
    filters: {
        tabHeader(value) {
            if (value === 'Two-Factor Authentication') {
                let screenWidth = screen.width;
                if (screenWidth < 720) {
                    return 'Authentication';
                }

                return value;
            } else {
                return value;
            }
        }
    },
    watch: {
        'userData'() {
            this._loadTopics();
        },

        'questionnaire'() {
            this._sycAppData();
        },

        'topics'() {
            this._sycAppData();
        }
    },
    mounted() {
        let self = this;

        self.$state.set("loading", true);
        self.loadUserData();
    },
    methods: {
        async loadUserData() {
            let self = this;

            await this.$authManager.getUser(function (user) {
                self.userData = user;
                self.$api.getUser(user).then(function (result) {
                    self.yourProfile = {
                        userName: result.eMail,
                        firstName: result.firstName,
                        lastName: result.lastName,
                        dateOfBirth: result.dateOfBirth ? moment(String(result.dateOfBirth)).format('MM/DD/YYYY') : null,
                        genderId: result.genderId,
                        postalCode: result.postalCode,
                        countryId: result.countryId,
                        showReset: result.showReset
                    };

                    self.yourCompany = {
                        jobLevelId: result.jobLevelId,
                        jobIndustryId: result.jobIndustryId,
                        departmentId: result.departmentId,
                        promoCode: result.promoCode,
                        promoCodeSaved: result.promoCode? true : false,
                        name: result.organizationName
                    };

                    if (self.yourProfile.showReset && !self.tabs.filter(function (tab) { return self.twoFactorTabName == tab.title; }).length) {
                        self.tabs.splice(2, 0, { title: self.twoFactorTabName, hash: '#twoFactor', index: 2 });
                    }
                    self.manage2FA = {
                        phoneNumber: result.phoneNumber,
                        phoneNumberVerificationCode: null,
                        enable2FAAuthentication: result.enableTwoFactorSMSAuthentication
                    };

                    self.emailAddresses = {
                        assignedEmails: result.userEmails
                    };

                    if (self.$router.currentRoute.hash == '#emailAddresses') {
                        var currentTab = self.tabs.filter(function (item) {
                            return item.hash == self.$router.currentRoute.hash;
                        })[0];

                        self.tab = 'tab-' + self.tabs.indexOf(currentTab);
                    }
                });

                self.$api.getCountries(user).then(function (response) {
                    self.countries = self._setEmptyOption(response);
                });

                self.$api.getGlobalTypesByName(user, 'gender').then(function (response) {
                    self.genders = self._setEmptyOption(response);
                });

                self.$api.getGlobalTypesByName(user, 'joblevel').then(function (response) {
                    self.jobLevels = self._setEmptyOption(response);
                });

                self.$api.getGlobalTypesByName(user, 'jobIndustry').then(function (response) {
                    self.jobIndustries = self._setEmptyOption(response);
                });

                self.$api.getGlobalTypesByName(user, 'department').then(function (response) {
                    self.departments = self._setEmptyOption(response);
                });
            });
        },

        async _loadTopics() {
            let self = this;

            self.$api.getQuestionnaire(self.userData).then(function (questionnaire) {
                self.topics = questionnaire.topics;
                self.questionnaire = questionnaire;
                self.questionnaire.topics = [];
            });
        },

        async _sycAppData() {
            let self = this;

            self.$state.set('loading', false);
            self.$state.set('topics', self.topics || []);
            self.$state.set('questionnaire', self.questionnaire || {});
            self.isLoaded = true;
        },

        _setEmptyOption(items) {
            if (items) {
                items.unshift({
                    id: null,
                    code: null,
                    value: 'Select One...',
                    name: 'Select One...',
                    orderNumber: 0
                });
            }

            return items;
        }
    }
}
